function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 22.5,
  cy: 22.5,
  r: 22,
  fill: "#004487",
  stroke: "#000"
});

var SvgClusterSbf = function SvgClusterSbf(props) {
  return React.createElement("svg", _extends({
    width: 45,
    height: 45,
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDUiIGhlaWdodD0iNDUiIHZpZXdCb3g9IjAgMCA0NSA0NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjIuNSIgY3k9IjIyLjUiIHI9IjIyIiBmaWxsPSIjMDA0NDg3IiBzdHJva2U9ImJsYWNrIi8+Cjwvc3ZnPgo=";
export { SvgClusterSbf as ReactComponent };